import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
const LABELS = {
    contest: {
        draft: 'Draft',
        scheduled: 'Scheduled',
        open: 'Open',
        closed: 'Closed',
        settled: 'Settled',
        canceled: 'Canceled',
    },
    entry: {
        editable: 'Editable',
        locked: 'Locked',
        settled: 'Settled',
        voided: 'Voided',
    },
    award: {
        pending: 'Pending',
        processing: 'Processing',
        delivered: 'Delivered',
        retryable: 'Retryable',
        failed: 'Failed',
        canceled: 'Canceled',
    },
};
// Maps each kind-state pair onto the shared tone it borrows its colours from
// (e.g. contest draft, entry editable and award pending are all the same grey).
const TONES = {
    'contest-draft': 'draft',
    'entry-editable': 'draft',
    'award-pending': 'draft',
    'contest-scheduled': 'scheduled',
    'entry-locked': 'scheduled',
    'award-processing': 'scheduled',
    'contest-open': 'open',
    'award-delivered': 'open',
    'contest-closed': 'closed',
    'award-canceled': 'closed',
    'contest-settled': 'settled',
    'entry-settled': 'settled',
    'contest-canceled': 'canceled',
    'entry-voided': 'canceled',
    'award-failed': 'canceled',
    'award-retryable': 'warn',
};
const pillVariants = cva([
    'inline-flex items-center gap-2 whitespace-nowrap rounded-pill border-[0.5px]',
    'py-1.5 pl-2.5 pr-3 font-ui text-[12.5px] font-medium leading-[1.45]',
].join(' '), {
    variants: {
        tone: {
            draft: 'bg-state-draft-bg text-state-draft-text border-state-draft-border',
            scheduled: 'bg-state-scheduled-bg text-state-scheduled-text border-state-scheduled-border',
            open: 'bg-state-open-bg text-state-open-text border-state-open-border',
            closed: 'bg-state-closed-bg text-state-closed-text border-state-closed-border',
            settled: 'bg-state-settled-bg text-state-settled-text border-state-settled-border',
            canceled: 'bg-state-canceled-bg text-state-canceled-text border-state-canceled-border',
            warn: 'bg-warn-soft text-warn border-[color-mix(in_srgb,var(--color-warn)_30%,var(--color-surface))]',
        },
    },
    defaultVariants: { tone: 'draft' },
});
const dotVariants = cva('h-[7px] w-[7px] flex-shrink-0 rounded-full', {
    variants: {
        tone: {
            draft: 'bg-state-draft-dot',
            scheduled: 'bg-state-scheduled-dot',
            open: 'bg-state-open-dot',
            closed: 'bg-state-closed-dot',
            settled: 'bg-state-settled-dot',
            canceled: 'bg-state-canceled-dot',
            warn: 'bg-warn',
        },
    },
    defaultVariants: { tone: 'draft' },
});
export function StatusPill({ kind = 'contest', state = 'draft', label, className, ...rest }) {
    const text = label ?? LABELS[kind][state] ?? state;
    const tone = TONES[`${kind}-${state}`] ?? 'draft';
    const pulsing = kind === 'contest' && state === 'open';
    return (_jsxs("span", { "data-kind": kind, "data-state": state, className: cn(pillVariants({ tone }), className), ...rest, children: [_jsx("span", { className: cn(dotVariants({ tone }), pulsing && 'animate-pulse-dot') }), text] }));
}
//# sourceMappingURL=status-pill.js.map